<template>
  <FormularioDinamico :id-formulario="nIdFormulario" :show-buttons="true"/>
</template>

<script>
import FormularioDinamico from '@/components/dinamicos/FormularioDinamico.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Dinamicos',
  components: {
    FormularioDinamico,
  },
  data() {
    return {
      nIdFormulario: 0,
    };
  },
  computed: {
    ...mapGetters(['getIdFormulario']),
  },
  mounted() {
    if (Object.keys(this.$route.params).length > 0) {
      this.nIdFormulario = parseInt(this.$route.params.idFormulario, 10);
    } else {
      this.nIdFormulario = this.getIdFormulario;
    }
  },
};
</script>
